import { ReferentialKey } from 'api/referential';
import { useAppSelector } from 'app/hooks';
import { NsKey } from 'enums/NsKey';
import { Sizes } from 'enums/sizes';
import { selectReferentialDataByKey } from 'features/referentials/selectors/selectReferentialDataByKey';
import { BorrowerLoanPanel } from 'features/subscription-process/profiling-process/forms/borrower-loan';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { usePanel } from 'hooks/usePanel';
import { useCallback, useMemo } from 'react';
import {
  useBorrowerContractualizationActions,
  useBorrowerGlobalInfos,
  useBorrowerId
} from '../../store';

export const useBorrowerRisk = (onRefresh?: () => void) => {
  const { openPanel } = usePanel();
  const globalInfos = useBorrowerGlobalInfos();
  const borrowerId = useBorrowerId();
  const { setGlobalInfos, fetchBorrowerDocuments } = useBorrowerContractualizationActions();
  const { t } = useDynamicTranslation([NsKey.Contractualization]);

  const loanTypes = useAppSelector(
    selectReferentialDataByKey(ReferentialKey.LoanType)
  );
  const interestRateTypes = useAppSelector(
    selectReferentialDataByKey(ReferentialKey.InterestRateType)
  );
  const defermentTypes = useAppSelector(
    selectReferentialDataByKey(ReferentialKey.DefermentType)
  );

  const referentials = useMemo(
    () => ({
      loanTypes,
      interestRateTypes,
      defermentTypes
    }),
    [loanTypes, interestRateTypes, defermentTypes]
  );

  const openLoanDetailsPanel = useCallback(() => {
    if (globalInfos && borrowerId)
      openPanel(
        {
          title: t('Les prêts'),
          size: Sizes['4xl']
        },
        <BorrowerLoanPanel
          borrowerId={borrowerId}
          onSuccess={(response) => {
            setGlobalInfos(response);
            onRefresh?.();
            if (globalInfos?.quoteId) {
              fetchBorrowerDocuments(globalInfos.quoteId);
            }
          }}
          referentials={referentials}
          isRenego
          showInlineSaveButton
        />
      );
  }, [openPanel, t, globalInfos, borrowerId, setGlobalInfos, fetchBorrowerDocuments, referentials, onRefresh]);

  const isEnabled = Boolean(globalInfos && borrowerId);

  return {
    openLoanDetailsPanel,
    isEnabled
  };
};
